import type { IForecastStatus } from '@/interfaces'

import { addToJSON } from './helper'

export class ForecastStatus implements IForecastStatus {
	field: string
	status: string
	tooltip: string

	constructor({ field, status, tooltip }: IForecastStatus) {
		this.field = field || ''
		this.status = status || ''
		this.tooltip = tooltip || ''
		addToJSON(ForecastStatus)
	}

	get statusClass(): string {
		switch (this.status) {
			case 'YELLOW':
				return 'warning'
			case 'ORANGE':
				return 'warning'
			case 'GREEN':
				return 'success'
			case 'RED':
				return 'danger'
			case 'BLUE':
				return 'info'
			default:
				return ''
		}
	}

	get statusIcon(): string {
		switch (this.field) {
			case 'probabilityOfSales':
				return 'percent'
			case 'hours':
				return 'clock'
			case 'estimatedContract':
				return 'dollar-sign'
			case 'buildLocation':
				return 'warehouse'
			case 'shipDate':
				return 'truck'
			case 'productionKickoffDate':
				return 'calendar'
			default:
				return ''
		}
	}

	toJSON(): string {
		return JSON.stringify(this)
	}
}
